import { Injectable } from '@angular/core';

import { FullActivity, FullCategory } from '../../../state/category/category.query';

@Injectable({
  providedIn: 'root',
})
export class ForecastTableGridUnitsService {
  parseCategoryUnits(category: FullActivity | FullCategory, isChild: boolean): string {
    if (!isChild) {
      return '-';
    }

    if ('unit_num' in category) {
      return `${category.unit_num || ''}`;
    }

    return '-';
  }
}
